/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/


import React from 'react'
import { useLoader } from 'react-three-fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import PeasField from './fields/PeasField';
import CabbageField from './fields/CabbageField';
import OnionField from './fields/OnionField';
import PoleBeansField from './fields/PoleBeansField';
import SpinacheField from './fields/SpinacheField';
import BroccoliField from './fields/BroccoliField';
import SweetCornField from './fields/SweetCornField';
import CauliflowerField from './fields/CauliflowerField';
import SavoyField from './fields/SavoyField';
import BabyliefField from './fields/BabyleafField';
import BrusselsSproutsField from './fields/BrusselsSproutsField';
import SquashField from './fields/SquashField';
import RomaineField from './fields/RomaineField';
import BataviaField from './fields/BataviaField';
import RadishField from './fields/RadishField';
import IcebergField from './fields/IcebergField';

function getPos(tile: number) {
  return tile * 5;
}

function tileToPlant(tile: number) {
  return tile * 2;
}

export default function Fields() {
  const { nodes: middleDirtNodes, materials: midleDirtMaterials } = useLoader<any>(GLTFLoader, 'assets/Middle/Middle_01_v001.gltf');
  const { nodes: straightDirtNodes, materials: straightDirtMaterials } = useLoader<any>(GLTFLoader, 'assets/Straight/Straight_01_v001.gltf');
  const { nodes: straightVertDirtNodes, materials: straightVertDirtMaterials } = useLoader<any>(GLTFLoader, 'assets/Straight/Straight_01_v001.gltf?vert=true');
  const { nodes: cornerDirtNodes, materials: cornerDirtMaterials } = useLoader<any>(GLTFLoader, 'assets/Corner/Corner_01_v001.gltf');
  const displayPopover = false;

  return (
    <>
    <PeasField
      position={[getPos(9), 0, getPos(4)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <SweetCornField
      position={[getPos(9), 0, getPos(9)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <PoleBeansField
      position={[getPos(9), 0, getPos(14)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <BabyliefField
      position={[getPos(21), 0, getPos(4)]}
      width={tileToPlant(13)}
      height={tileToPlant(10)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <BataviaField
      position={[getPos(21), 0, getPos(14)]}
      width={tileToPlant(13)}
      height={tileToPlant(10)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <IcebergField
      position={[getPos(21), 0, getPos(23.9)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    

    <RomaineField
      position={[getPos(33), 0, getPos(4)]}
      width={tileToPlant(4)}
      height={tileToPlant(13)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <SpinacheField
      position={[getPos(33), 0, getPos(16.7)]}
      width={tileToPlant(4)}
      height={tileToPlant(13)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    
    <SavoyField
      position={[getPos(37.7), 0, getPos(4)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <CabbageField
      position={[getPos(37.7), 0, getPos(9)]}
      width={tileToPlant(13)}
      height={tileToPlant(10)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <BrusselsSproutsField
      position={[getPos(37.7), 0, getPos(19)]}
      width={tileToPlant(13)}
      height={tileToPlant(10)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <RadishField
      position={[getPos(49.6), 0, getPos(4)]}
      width={tileToPlant(4)}
      height={tileToPlant(13)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <OnionField
      position={[getPos(49.6), 0, getPos(16.7)]}
      width={tileToPlant(4)}
      height={tileToPlant(13)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    
    <SquashField
      position={[getPos(54.5), 0, getPos(4)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
    
    <BroccoliField
      position={[getPos(54.5), 0, getPos(9)]}
      width={tileToPlant(13)}
      height={tileToPlant(4)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
   
    <CauliflowerField
      position={[getPos(54.5), 0, getPos(14)]}
      width={tileToPlant(13)}
      height={tileToPlant(16.3)}
      displayPopover={displayPopover}
      models={{
        middleDirt: {
          nodes: middleDirtNodes,
          materials: midleDirtMaterials,
        },
        straightDirt: {
          nodes: straightDirtNodes,
          materials: straightDirtMaterials,
        },
        straightVertDirt: {
          nodes: straightVertDirtNodes,
          materials: straightVertDirtMaterials,
        },
        cornerDirt: {
          nodes: cornerDirtNodes,
          materials: cornerDirtMaterials,
        },
      }}
    />
  </>
  )
}
